export const LOAD_ADDRESSES = 'load_addresses';
export const ADDRESSES_LOADED = 'set_loaded_addresses';
export const RESET_ADDRESSES = 'reset_addresses';
export const SYNC_FAILED = 'addresses_sync_error';
